import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './config/msalConfig'; // ← NUEVO IMPORT
import { AuthProvider } from './contextProviders/AuthProvider';
import { SiteModeProvider } from './contextProviders/SiteModeProvider';
import { UserProfileProvider } from './contextProviders/UserProfileProvider';
import { HostProfileProvider } from './contextProviders/HostProfileProvider';
import { ServiceProviderProfileProvider } from './contextProviders/ServiceProviderProfileProvider';
import { IncomingBookingsProvider } from './contextProviders/IncomingBookingsProvider';
import { IncomingServiceRequestsProvider } from './contextProviders/IncomingServiceRequestsProvider';
import AppRoutes from './routes/AppRoutes';
import CookieConsentBanner from './components/CookieConsent';
import ToastContainer from './components/Toast/ToastContainer';
import Analytics from './components/Analytics';

// ===== INITIALIZE MSAL - NUEVO =====
const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  return (
    <MsalProvider instance={msalInstance}> {/* ← NUEVO WRAPPER */}
      <BrowserRouter>
        <AuthProvider>
          <SiteModeProvider>
            <UserProfileProvider>
              <HostProfileProvider>
                <ServiceProviderProfileProvider>
                  <IncomingBookingsProvider>
                    <IncomingServiceRequestsProvider>
                      <Analytics />
                      <AppRoutes />
                      <CookieConsentBanner />
                      <ToastContainer />
                    </IncomingServiceRequestsProvider>
                  </IncomingBookingsProvider>
                </ServiceProviderProfileProvider>
              </HostProfileProvider>
            </UserProfileProvider>
          </SiteModeProvider>
        </AuthProvider>
      </BrowserRouter>
    </MsalProvider>
  );
}

export default App;
